import React from 'react';
import styles from './Finance.module.css';

const Finance = ({ lang }) => {
  // Content Data
  const data = {
    EN: {
      title: "Finance & Markets",
      btn: "View All Market Reports",
      news: [
        { title: "Global Market Rally: Stocks reach new record heights" },
        { title: "Gold prices witness sudden global spike" },
        { title: "Tech stocks leading the 2026 growth" },
        { title: "Central Bank updates interest rate policies" },
        { title: "Crypto assets stability analysis" },
        { title: "Future of E-commerce in emerging markets" }
      ]
    },
    UR: {
      title: "مالیات اور مارکیٹ",
      btn: "تمام مارکیٹ رپورٹس دیکھیں",
      news: [
        { title: "عالمی مارکیٹ میں تیزی: اسٹاکس نئی بلندیاں چھو رہے ہیں" },
        { title: "سونے کی قیمتوں میں اچانک عالمی اضافہ" },
        { title: "ٹیک اسٹاکس 2026 کی گروتھ میں سر فہرست" },
        { title: "مرکزی بینک کی سود کی شرح پالیسی میں اپ ڈیٹ" },
        { title: "کرپٹو اثاثوں کی استحکام کا تجزیہ" },
        { title: "ابھرتی ہوئی مارکیٹوں میں ای کامرس کا مستقبل" }
      ]
    }
  }[lang];

  return (
    <section className={styles.finSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.finGrid}>
        {data.news.map((item, i) => {
          // Pehli news ko 'featured' (bada) banane ka logic
          const cardClass = (i === 0) ? styles.featured : "";
          
          return (
            <div key={i} className={`${styles.finCard} ${cardClass}`}>
              <img 
                src={`https://picsum.photos/600/600?random=${i + 9000}`} 
                alt="finance" 
              />
              <div className={styles.overlay}>
                <h4>{item.title}</h4>
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Finance;